const urlRegex =
  /((http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!]))?[A_Za-zА-Яа-я0-9])\/?/gi
const emailRegExp = /([A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,4})/gi

const urlify = (text: string) => {
  return text
    .replace(urlRegex, '<a href="$1" target="_blank" style="color: #19b5ff">$1</a>')
    .replace(emailRegExp, '<a href="mailto:$1" target="_blank" style="color: #19b5ff">$1</a>')
}

export { urlify }
